








































































































































import { Button, MDInput } from "@micad/vue-components";
import { computed, defineComponent, reactive } from "@vue/composition-api";
import router from "@/router";
import {
  resetPassword,
  ResetPasswordRequest,
} from "@/data/repos/passwordReset";
import config from "@/config";
import Vue from "vue";

export default defineComponent({
  components: {
    Button,
    MDInput,
  },
  setup() {
    const query = router.currentRoute.query;
    const state = reactive({
      password: "",
      passwordConfirmation: "",
      passwordError: "",
      confirmPasswordError: "",
      errorMessage: "",
      clientId: String(router.currentRoute.query.clientId! || ""),
      userId: parseInt(String(router.currentRoute.query.userId! || "")),
      returnUrl: String(router.currentRoute.query.returnUrl! || ""),
      resetToken: router.currentRoute.query.resetToken || null,
      gotValidParameters: computed(
        () =>
          !isNaN(parseInt(String(router.currentRoute.query.userId! || ""))) &&
          typeof router.currentRoute.query.resetToken === "string"
      ),
    });
    async function submit() {
      state.passwordError = "";
      state.confirmPasswordError = "";
      if (state.password !== state.passwordConfirmation) {
        state.confirmPasswordError = "Passwords do not match";
        return;
      }
      const req = {
        clientId: state.clientId,
        userId: state.userId,
        resetToken: state.resetToken,
        newPassword: state.password,
      } as ResetPasswordRequest;
      const resp = await resetPassword(req);
      if (resp.ok) {
        if (query.originalUrl && typeof query.originalUrl === "string") {
          const originalUrl = (() => {
            try {
              return new URL(query.originalUrl);
            } catch {
              return null;
            }
          })();
          // if the host of the returnUrl parameter in the originalUrl
          // is the same as current page host - redirect to default URL
          // otherwise redirect to original
          if (
            originalUrl &&
            originalUrl
              .searchParams!.get("returnUrl")!
              .search(window.location.host) > -1 &&
            config.DEFAULT_REDIRECT_URL
          )
            window.location.href = config.DEFAULT_REDIRECT_URL;
          else window.location.replace(query.originalUrl);
        } else if (config.DEFAULT_REDIRECT_URL) {
          window.location.href = config.DEFAULT_REDIRECT_URL;
        } else {
          await router.push("/");
        }
      } else if (resp.response!.data.errorType === "password") {
        Vue.$toast.error(resp.response!.data.errorMessage);
      }
      if (resp.response!.data.errorType === "newPassword") {
        state.passwordError = resp.response!.data.errorMessage;
      }
    }
    return { state, submit };
  },
});
